<template>
  <div v-if="chartData.length" class="root">
    <div class="pie">
      <div
        v-for="item in chartData"
        :key="item.creditsUsed"
        :class="{ slice: true, big: item.arc > 180 }"
        :style="`transform: rotate(${item.offset}deg)`"
      >
        <span :style="`transform: rotate(${item.arc}deg)`"></span>
      </div>
      <div class="center stats">
        <span>avg. per user</span>
        <strong>{{ averagePerStudent.toLocaleString() }}</strong>
      </div>
    </div>

    <ul class="legend">
      <li v-for="item in chartData" :key="item.creditsUsed" class="item">
        <span class="square" />
        {{ item.students.toLocaleString() }} users used
        <span class="credits">
          {{ item.creditsUsed.toLocaleString() }}
          <img src="@/assets/icon/icon-credit.svg" alt="Credit" />
        </span>
      </li>
    </ul>
  </div>
  <div v-else class="empty">No Usage Data</div>
</template>

<script>
export default {
  name: 'DistributionChart',

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    averagePerStudent: {
      type: Number,
      default: () => 0
    },

    histogram: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    chartData() {
      const totalStudents = this.histogram.reduce((a, e) => a + e.students, 0);

      let offset = 0;
      const chartData = [];

      for (let i = 0; i < this.histogram.length; i++) {
        const { students, creditsUsed } = this.histogram[i];

        const arc = (360 * students) / totalStudents;
        chartData.push({
          students,
          creditsUsed,
          offset,
          arc
        });

        offset += arc;
      }

      return chartData;
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  display: flex;
  padding: 0 2.45rem;
  flex-direction: column;

  @media screen and (min-width: $sm-min) and (max-width: $md-max) {
    flex-direction: row;
  }

  @media screen and (min-width: $xl-min) {
    flex-direction: row;
  }
}

.empty {
  width: calc(100% - 4.9rem);
  margin: 0 2.45rem;
}

.pie {
  display: block;
  min-width: 200px;
  width: 100%;
  margin: 0 2rem 2rem 1rem;
  min-height: 200px;
  max-width: 200px;
  max-height: 200px;
  position: relative;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 16%;
  right: 16%;
  bottom: 16%;
  left: 16%;
  background: white;
  border-radius: 50%;
  box-shadow: inset 0px 4px 4px -5px rgb(0 0 0 / 50%);
  z-index: 3;

  &.stats {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
    color: #76788e;
    font-weight: 500;
    font-size: 16px;
    text-align: center;

    > span {
      margin-bottom: 0.25rem;
    }

    > strong {
      font-size: 22px;
      color: #1d1c1c;
    }
  }
}

.slice {
  @include pie-color-list('span');
  @include pie-color-list(':after');
  position: absolute;
  width: 100px;
  height: 200px;
  overflow: hidden;
  left: 100px;
  transform-origin: left center;
  transition: all 1s ease;

  &:first-child {
    z-index: 1;
  }

  > span:first-child {
    position: absolute;
    width: 100px;
    height: 200px;
    left: -100px;
    border-radius: 100px 0 0 100px;
    transform-origin: right center;
    outline-offset: 10px;
  }

  &.big {
    overflow: visible;

    > span:first-child {
      left: -100px;
    }

    &:after {
      content: '';
      position: absolute;
      width: 100px;
      height: 200px;
      left: 0px;
      border-radius: 0 100px 100px 0;
    }
  }
}

.legend {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  padding-left: 1rem;
  color: #76788e;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;

  .item {
    display: inline-flex;
    padding: 4px;
    margin: 0 8px 8px 0;
    font-size: 1rem;
    letter-spacing: -0.015rem;

    .square {
      display: inline-block;
      height: 16px;
      width: 16px;
      background: $dark-blue;
      border-radius: 1px;
      margin-right: 8px;
    }

    @include use-color-list('.square');
  }
}

.credits {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  line-height: 1;
  margin-left: 6px;
  font-weight: 700;

  img {
    height: 13px;
    opacity: 0.66;
    margin-left: 3px;
  }
}
</style>
